import React from 'react';
import './IntroTemplate.css';

const IntroTemplate = ({ logo, title, image }) => {
  // Ensure the image path is properly encoded
  const encodedImagePath = encodeURI(image);

  return (
    <div
      className="IntroTemplate-container"
      style={{ backgroundImage: `url(${encodedImagePath})` }}
    >
      <img src={logo} alt="Logo" className="IntroTemplate-logo" />
      <h1 className="IntroTemplate-title">{title}</h1>
    </div>
  );
};

export default IntroTemplate;
